import { computed, observable } from 'mobx';
import { INewArtifactViewHistory, INewCollectionViewHistory, ViewHistory } from '../_interfaces/ViewHistory';
import { ViewHistoryService } from '../_services/ViewHistoryService';
import { AbstractStore } from './AbstractStore';

export class ViewHistoryStore extends AbstractStore {
    private _service: ViewHistoryService;
    @observable private _viewHistoriesByArtifactID: Map<number, ViewHistory> = new Map();
    @observable private _collectionViewHistoryMap: Map<number, ViewHistory> = new Map();

    @computed
    public get collectionViewHistoryMap(): Map<number, ViewHistory> {
        return this._collectionViewHistoryMap;
    }

    @computed
    public get viewHistoriesByArtifactID(): Map<number, ViewHistory> {
        return this._viewHistoriesByArtifactID;
    }

    public constructor(authToken: string) {
        super();
        this._service = new ViewHistoryService(authToken);
    }

    public updateArtifactViewHistory(artifact_id: number): Promise<void> {
        console.assert(artifact_id, 'Paramater is undefined');

        const viewHistory: INewArtifactViewHistory = {
            artifact_id
        };
        return this._service.create(viewHistory).then((response) => {
            return;
        });
    }

    public updateCollectionViewHistory(collection_id: number): Promise<void> {
        console.assert(collection_id, 'Paramater is undefined');

        const viewHistory: INewCollectionViewHistory = {
            collection_id
        };

        return this._service.create(viewHistory).then((response) => {
            return;
        });
    }

    protected loadData(): Promise<void> {
        return this._service.getAll().then((records: Array<ViewHistory>) => {
            this.addRecordsToMap(records);
        });
    }

    protected addRecordsToMap(records: Array<ViewHistory>): void {
        console.assert(records, 'Paramater is undefined');

        records.forEach((viewHistory) => {
            if (typeof viewHistory.artifact_id !== 'undefined') {
                this._viewHistoriesByArtifactID.set(viewHistory.artifact_id, viewHistory);
            }
            if (typeof viewHistory.collection_id !== 'undefined') {
                this._collectionViewHistoryMap.set(viewHistory.collection_id, viewHistory);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/_stores/ViewHistoryStore.ts